// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-tab-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
    min-height: 0;
    padding: 14px 16px;
    background: #fff;
    border-top: 3px solid #1faeff;
}

.ai-sub-tabs {
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 12px;
}

.ai-sub-tabs button {
    padding: 6px 14px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    font-size: 13px;
    color: #666;
    transition: all 0.2s;
}

.ai-sub-tabs button:hover {
    color: #333;
    background-color: #f9f9f9;
}

.ai-sub-tabs button.active {
    color: #1faeff;
    border-bottom-color: #1faeff;
    font-weight: 600;
}

.ai-result {
    padding: 6px 12px 12px 12px;
    background-color: #f8f9fa;
    border-radius: 6px;
    /* border-left: 4px solid #1faeff; */
}

.ai-result h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
}

.ai-result p {
    margin: 0;
    line-height: 1.6;
    color: #444;
    font-size: 14px;
}

.ai-result h2 {
    margin: 0 0 16px;
    font-size: 16px;
    color: #333;
}

.summary-format-section {
    margin-bottom: 0.75rem;
}

.format-label {
    font-size: 13px;
    color: #333;
    font-weight: 500;
    margin: 0 0 6px 0;
    display: block;
}

.format-select {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 13px;
    background-color: white;
    cursor: pointer;
    margin-bottom: 10px;
}

.format-select:focus {
    outline: none;
    border-color: #1faeff;
    box-shadow: 0 0 0 3px rgba(31, 174, 255, 0.1);
}

.format-description {
    font-size: 12px;
    color: #666;
    margin: 0 0 6px 0;
}

.format-input {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 13px;
}

.format-input:focus {
    outline: none;
    border-color: #1faeff;
    box-shadow: 0 0 0 3px rgba(31, 174, 255, 0.1);
}

.ai-status-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    background-color: #fff3cd;
    border-radius: 6px;
    border: 1px solid #ffc107;
    margin-top: 12px;
    margin-bottom: 12px;
}

.ai-status-message {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #856404;
    font-size: 13px;
}

.spinner-small {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid rgba(133, 100, 4, 0.3);
    border-radius: 50%;
    border-top-color: #856404;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/Magor/Recording/AITab.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,eAAe;IACf,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".ai-tab-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    width: 100%;\n    min-height: 0;\n    padding: 14px 16px;\n    background: #fff;\n    border-top: 3px solid #1faeff;\n}\n\n.ai-sub-tabs {\n    display: flex;\n    border-bottom: 1px solid #e0e0e0;\n    margin-bottom: 12px;\n}\n\n.ai-sub-tabs button {\n    padding: 6px 14px;\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    cursor: pointer;\n    font-size: 13px;\n    color: #666;\n    transition: all 0.2s;\n}\n\n.ai-sub-tabs button:hover {\n    color: #333;\n    background-color: #f9f9f9;\n}\n\n.ai-sub-tabs button.active {\n    color: #1faeff;\n    border-bottom-color: #1faeff;\n    font-weight: 600;\n}\n\n.ai-result {\n    padding: 6px 12px 12px 12px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    /* border-left: 4px solid #1faeff; */\n}\n\n.ai-result h3 {\n    margin: 0;\n    font-size: 18px;\n    color: #333;\n}\n\n.ai-result p {\n    margin: 0;\n    line-height: 1.6;\n    color: #444;\n    font-size: 14px;\n}\n\n.ai-result h2 {\n    margin: 0 0 16px;\n    font-size: 16px;\n    color: #333;\n}\n\n.summary-format-section {\n    margin-bottom: 0.75rem;\n}\n\n.format-label {\n    font-size: 13px;\n    color: #333;\n    font-weight: 500;\n    margin: 0 0 6px 0;\n    display: block;\n}\n\n.format-select {\n    width: 100%;\n    padding: 8px 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 13px;\n    background-color: white;\n    cursor: pointer;\n    margin-bottom: 10px;\n}\n\n.format-select:focus {\n    outline: none;\n    border-color: #1faeff;\n    box-shadow: 0 0 0 3px rgba(31, 174, 255, 0.1);\n}\n\n.format-description {\n    font-size: 12px;\n    color: #666;\n    margin: 0 0 6px 0;\n}\n\n.format-input {\n    width: 100%;\n    padding: 8px 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 13px;\n}\n\n.format-input:focus {\n    outline: none;\n    border-color: #1faeff;\n    box-shadow: 0 0 0 3px rgba(31, 174, 255, 0.1);\n}\n\n.ai-status-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 12px;\n    background-color: #fff3cd;\n    border-radius: 6px;\n    border: 1px solid #ffc107;\n    margin-top: 12px;\n    margin-bottom: 12px;\n}\n\n.ai-status-message {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #856404;\n    font-size: 13px;\n}\n\n.spinner-small {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border: 2px solid rgba(133, 100, 4, 0.3);\n    border-radius: 50%;\n    border-top-color: #856404;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
